import React from "react";
import PropTypes from "prop-types";

/**
 * Shared section heading (eyebrow rule + title + optional description).
 *
 * The `.section-title` wrapper and the h2 are load-bearing selectors for
 * e2e/sections.spec.js.
 */
const SectionTitle = ({ title, description, align = "center" }) => (
  <div
    className={`section-title ${align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl text-left"}`}
  >
    <h2 className="text-fluid-2xl font-bold tracking-tight text-ink-900">
      {title}
    </h2>
    <div
      className={`mt-4 h-1 w-14 rounded-full bg-brand-600 ${align === "center" ? "mx-auto" : ""}`}
      aria-hidden="true"
    />
    {description ? (
      <p className="mt-5 text-fluid-base leading-relaxed text-ink-500">
        {description}
      </p>
    ) : null}
  </div>
);

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  align: PropTypes.oneOf(["center", "left"]),
};

export default SectionTitle;
